

const state = {
   def_plat: null,//默认媒体
};

const mutations = {
    ADD_DEF_PLAT(state, playload) {
        state.def_plat = playload;
    }
};
const actions = {
    
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
